<template>
    <a :href="'https://app.azurity.nl/account/register/professional'" target="_blank" class="btn btn-outline-azure btn-wide btn-lg mb-3" aria-label="Aanmelden als beveiliger">
        <span>Aanmelden als <br /> <span>{{type}}</span></span>
        <div class="btn-icon">
            <span>&rarr;</span>
        </div>
    </a>
</template>

<script>
export default {
    name: 'register-button-pro',
    props: {
        type: {
            type: String,
            default: 'beveiliger'
        }
    }
}
</script>